<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 1120px;
  width: 100%;
  margin: 0 auto;
}
body {
  margin: 0;
  padding: 0;
}
html,
body,
#app {
  height: 100%;
}
.bac-sjx1 {
  width: 0;
  height: 0;
  border-width: 0 50px 50px;
  border-style: solid;
  border-color: transparent transparent #f8f8f8;
  position: absolute;
  top: -16px;
  left: 100px;
}
.bac-sjx2 {
  width: 0;
  height: 0;
  border-width: 0 50px 50px;
  border-style: solid;
  border-color: transparent transparent #ffffff;
  position: absolute;
  top: -16px;
  left: 100px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue